import React, { useMemo } from 'react';
import errorIcon from '../../assets/error.svg';
import succesIcon from '../../assets/done-success.svg';
import infoIcon from '../../assets/info-i.svg';
import './FigoInputMessage.css';

const TYPE = {
  error: 'error',
  info: 'info',
  success: 'success',
};

const FigoInputMessage = ({
  id = '',
  message = '',
  type = TYPE.error,
  noBlankSpace = false,
}) => {
  const className = useMemo(() => `Figo-input-message-${type
    || 'error'}`
    + ` ${noBlankSpace
      ? 'Figo-input-message-no-blank' : ''}`, [type, noBlankSpace]);
  const icon = useMemo(() => {
    switch (type) {
      case TYPE.info:
        return infoIcon;
      case TYPE.success:
        return succesIcon;
      case TYPE.error:
      default:
        return errorIcon;
    }
  }, [type]);
  return (
    <div className={className} id={id}>
      {message ? (
        <>
          <img alt="" src={icon} />

          {message}
        </>
      ) : null}
    </div>
  );
};

export { FigoInputMessage };
